module.exports = __webpack_public_path__ + "img/SketchPng0eb02226ca68e9858231db2513cd921d1266f35f3c9f6e18fff95e47a91f20a9.36faf8a7.png";